import { Box, Typography } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export type DesviosCriticosCardProps = {
    value?: number;
};

export default function DesviosCriticosCard({ value }: DesviosCriticosCardProps) {
    const formattedValue = value !== undefined && value !== null
        ? `${Math.round(value).toLocaleString("pt-BR")} MWh`
        : "---";

    return (
        <Box
            sx={{
                backgroundColor: "rgba(251, 191, 36, 0.1)",
                borderRadius: "8px",
                padding: "14px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "6px",
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
                <WarningAmberIcon sx={{ color: "#FBBF24", fontSize: "20px", marginRight: "8px" }} />
                <Typography sx={{ fontSize: "14px", color: "#FBBF24", fontWeight: "500" }}>
                    Desvios Críticos do Período
                </Typography>
            </Box>
            <Box>
                <Typography sx={{ fontSize: "18px", textAlign: "left", fontWeight: "700", color: "#FBBF24" }}>
                    {formattedValue}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#FBBF24" }}>
                    {"Perdas gerenciáveis que impactaram as metas"}
                </Typography>
            </Box>
        </Box>
    );
}
